import clsx from 'clsx'
import { AiDrawer } from '../../../shared/components/ai/ai-drawer/AiDrawer'
import { DetectMoreAds } from '../../../shared/components/utility/detect-more-ads/DetectMoreAds'
import { useAnalytics } from './hooks/UseAnalytics'
import { useMenuLayout } from './hooks/UseMenuLayout'
import { useNotifications } from '../../../shared/lib/hooks/UseNotifications'
import { useTariffDetails } from './hooks/UseTariffDetails'
import { SidebarMenuLayout } from './components/sidebar-menu-layout/SidebarMenuLayout'
import { TopMenuLayout } from './components/top-menu-layout/TopMenuLayout'
import { EmailVerifyBar } from './ui/EmailVerifyBar'
import { ImpersonateBar } from './ui/ImpersonateBar'
import { ReferralBanner } from './ui/ReferralBanner'

export const MainLayout = () => {
  const { menuLayout } = useMenuLayout()

  useNotifications()
  useTariffDetails()
  useAnalytics()

  return (
    <main
      className={clsx('relative flex min-h-screen min-w-[360px] flex-col bg-grey', {
        // Сайдбару нужна точная высота контейнера: при min-h-screen высота растёт по
        // содержимому, и ни лэйаут, ни меню не знают, где низ экрана.
        // [height:100dvh] — чтобы на мобильном не уезжать под адресную строку
        ['h-screen overflow-hidden [height:100dvh]']: menuLayout === 'sidebar',
      })}
    >
      <div className={'relative z-30 w-full bg-focus-500'}>
        <ReferralBanner />
        <EmailVerifyBar />
        {menuLayout === 'top' ? <ImpersonateBar /> : null}
      </div>
      <div className={'flex min-h-0 flex-1 flex-col'}>
        {menuLayout === 'top' ? <TopMenuLayout /> : <SidebarMenuLayout />}
      </div>
      <div>
        <AiDrawer />
        <DetectMoreAds />
      </div>
    </main>
  )
}
